var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiUnitHourly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-3 {\n        stroke-dasharray: 0 3.06;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.74,21.67c-4.59,0-8.35-3.76-8.35-8.35,0-4.59,3.76-8.35,8.35-8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.74,21.67c2.72,0,5.14-1.32,6.67-3.35"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.4,18.32c1.05-1.4,1.68-3.13,1.68-5,0-4.59-3.76-8.35-8.35-8.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "16.04 16.7 11.48 13.97 11.48 8.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.37,8.83c0-1.79-1.45-3.25-3.25-3.25,1.79,0,3.25-1.45,3.25-3.25,0,1.79,1.45,3.25,3.25,3.25-1.79,0-3.25,1.45-3.25,3.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUnitHourly);
export default __webpack_public_path__ + "static/media/AIUnitHourly.a4d186d67dea005a398d4bad2f374756.svg";
export { ForwardRef as ReactComponent };